import { useMutation } from "@tanstack/react-query";

import { AmplitudeApi } from "@/api/amplitude";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { useSendForgotPassword } from "@/features/forms/forgot-password-form/hooks";
import {
  InfoModalSignUpResDto,
  SignUpErrorResDto,
} from "@/models/infoModalRes.dto";

import { SignUpFormApi } from "../api";
import { bingReportSignUp } from "../helpers";

export const isErrorSignUpResDto = (
  data: InfoModalSignUpResDto,
): data is SignUpErrorResDto => data.statusReg === "fail";

export const useSendSignUpForm = () => {
  const { openModal, removeOne } = useOpenModal();
  const openSignInModal = () => {
    openModal("SIGN_IN_FORM_MODAL", { onClose: removeOne });
  };

  const { mutate: sendForgotPassword } = useSendForgotPassword();

  const openInfoModal = ({ ex, statusReg }: SignUpErrorResDto) => {
    openModal("INFORMATION_MODAL", { message: ex, statusReg });
  };

  const openRecoverSuggestModal = (
    dto: SignUpErrorResDto,
    username: string,
  ) => {
    openModal("RECOVER_SUGGEST_MODAL", {
      message: dto.ex,
      statusReg: dto.statusReg,
      onSignInClick: openSignInModal,
      onRecoverClick: () => sendForgotPassword({ username }),
    });
  };

  return useMutation(SignUpFormApi.send, {
    onSuccess: async (data, variables) => {
      if (data && isErrorSignUpResDto(data)) {
        const isPasswordRecoverSuggest = data.eventCode === 1000;

        if (isPasswordRecoverSuggest) {
          openRecoverSuggestModal(data, variables.username);
        } else {
          openInfoModal(data);
        }

        await AmplitudeApi.send({
          amplitude: "sign_up",
          signup_method: "sign_up",
          error: true,
        });

        return;
      }

      bingReportSignUp();

      await AmplitudeApi.send({
        amplitude: "sign_up",
        signup_method: "sign_up",
        error: false,
      });
    },
  });
};
